import Base from 'app/models/base';

export default Base.extend({
  initialize({ choices, paramKey, label, staticKey, initialChoice }) {
    this.choices = choices;
    this.paramKey = paramKey;
    this.label = label;
    this.staticKey = staticKey;
    this.setInitialCurrentChoice(initialChoice);
  },

  getVal() {
    return this.get('currentChoice').option;
  },

  getReadable() {
    return this.get('currentChoice').readable;
  },

  getParams() {
    const val = this.getVal();
    return val ? { [this.paramKey]: val, ...this.staticKey } : {};
  },

  setInitialCurrentChoice(choiceString) {
    let choice;
    if (!choiceString) {
      choice = this.choices[0];
    } else {
      choice = this.choices.find(choice => choice.option === choiceString);
      if (!choice) throw Error('The choice that you passed is not in the choices array.');
    }
    this.set('currentChoice', choice);
  },
});



// WEBPACK FOOTER //
// ./app/models/dropdown_selection.js